/* eslint-disable no-unused-vars */
import { Image, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

// Imagen de Grupo Falabella (Nueva imagen agregada antes de las otras)
import grupoFalabellaImg from "assets/images/falabella/color/SGF.png";

const items = [
  {
    id: "1",
    srcWeb: require("assets/images/img/logos/corporativo.png"),
    redirect: "/falabellacorp",
    to: "Falabella Equipo Corporativo",
  },
  {
    id: "2",
    srcWeb: require("assets/images/falabella/color/Retail_f.com.png"),
    redirect: "/falabellaretail",
    to: "Falabella Retail",
  },
  {
    id: "3",
    srcWeb: require("assets/images/img/logos/sodimac.png"),
    redirect: "/sodimac",
    to: "Sodimac",
  },
  {
    id: "4",
    srcWeb: require("assets/images/img/logos/tottus.png"),
    redirect: "/tottus",
    to: "Tottus",
  },
  {
    id: "5",
    srcWeb: require("assets/images/img/logos/mallplaza.png"),
    redirect: "/mallplaza",
    to: "Mallplaza",
  },
  {
    id: "6",
    srcWeb: require("assets/images/img/logos/banco.png"),
    redirect: "/bancofalabella",
    to: "Banco Falabella",
  }
];

const FooterBrands = () => {
  return (
    <Row className="justify-content-center align-items-center text-center py-4">
      {/* Imagen de Grupo Falabella */}
      <Col xs="auto">
        <Image src={grupoFalabellaImg} style={{ maxHeight: "50px", width: "auto" }} />
      </Col>

      {/* Pipe separador visible */}
      <Col xs="auto">
        <span style={{ fontSize: "1.5rem", color: "white", fontWeight: "bold" }}>|</span>
      </Col>

      {/* Logos de las marcas */}
      {items.map((item) => (
        <Col xs="auto" key={item.id}>
          <Link to={item.redirect}>
            <Image src={item.srcWeb} style={{ maxHeight: "50px", width: "auto" }} />
          </Link>
        </Col>
      ))}
    </Row>
  );
};

export default FooterBrands;
